import type { UnitTab } from '../units/units.paths';

/**
 * A trailer's address by id, for a link that has only the id to hand: it opens the unit the trailer is part of, or the spare
 * trailer's own page (`RedirectToUnit`). With the registration to hand, link with `unitPath` and skip the redirect.
 */
export function trailerTabPath(id: string, tab: UnitTab): string {
  return `/fleet/trailers/${id}/${tab}`;
}
